export const CARD_MESSAGES = {
  accountNotFound: 'Número de cuenta incorrecto.',
  accountInvalid: 'Faltan uno o más datos y no se pudo completar la solicitud.',
  accountHasNoCards: 'La cuenta consultada no posee tarjetas.',
  accountNotAllowed:
    'Acceso denegado. El número de cuenta ingresado no existe en su organización.',
  accountNotAllowedToCostCenter:
    'Cuenta no asociada a su centro de costos. Por favor, consulte con el administrador.',
};
